<template>
  <div>
    <section class="card page-header">
      <div>
        <span class="eyebrow">USER MANAGEMENT</span>
        <h2>用户管理</h2>
        <p>查看微信用户、客户资料、签约设备和签约记录。</p>
      </div>
      <div class="page-actions">
        <input
          v-model.trim="keyword"
          @keyup.enter="load"
          placeholder="昵称、姓名、手机号、地址、机具编号或SN"
        /><button @click="load">搜索</button>
      </div>
    </section>
    <section class="card table-card">
      <div class="table-scroll" v-if="rows.length">
        <table>
          <thead>
            <tr>
              <th>用户</th>
              <th>客户姓名</th>
              <th>签约手机号</th>
              <th>签约地址</th>
              <th>机具编号</th>
              <th>设备SN</th>
              <th>签约人</th>
              <th>绑定设备</th>
              <th>已签协议</th>
              <th>最近签约</th>
              <th>注册时间</th>
              <th>上传资料</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in rows" :key="x.id">
              <td>
                <div class="user-cell">
                  <img v-if="x.avatar_url" :src="x.avatar_url" /><span v-else>{{
                    (x.nickname || "用").slice(0, 1)
                  }}</span>
                  <div>
                    <b>{{ x.nickname || "未设置昵称" }}</b
                    ><small>用户编号 #{{ x.id }}</small>
                  </div>
                </div>
              </td>
              <td>{{ x.customer_name || "-" }}</td>
              <td>{{ x.signed_phone || x.mobile || "-" }}</td>
              <td class="address-cell" :title="x.signed_address">{{ x.signed_address || "-" }}</td>
              <td class="code-cell">{{ x.machine_code || "-" }}</td>
              <td class="code-cell">{{ x.device_sn || "-" }}</td>
              <td>{{ x.customer_name || "-" }}</td>
              <td>{{ x.device_count }}</td>
              <td>{{ x.agreement_count }}</td>
              <td>{{ x.last_signed_at || "-" }}</td>
              <td>{{ x.created_at }}</td>
              <td><button class="photo-button" @click="viewPhotos(x)">查看上传图片</button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="empty-state">
        <div class="empty-icon">用</div>
        <h3>暂无匹配用户</h3>
      </div>
    </section>
    <div class="photo-mask" v-if="photoDialog" @click.self="closePhotos">
      <div class="photo-dialog">
        <div class="dialog-head"><div><h3>{{photoUser.nickname||'用户'}}的上传图片</h3><p>用户编号 #{{photoUser.id}}，共 {{photos.length}} 张</p></div><button class="close" @click="closePhotos">×</button></div>
        <div class="photo-toolbar" v-if="photos.length"><label><input type="checkbox" :checked="allPhotosSelected" @change="toggleAllPhotos"> 全选</label><span>已选择 {{selectedPhotoIds.length}} 张</span><button class="danger" :disabled="!selectedPhotoIds.length" @click="deletePhotos(selectedPhotoIds)">批量删除</button></div>
        <div class="photo-grid" v-if="photos.length"><div class="photo-item" v-for="x in photos" :key="x.id"><label class="photo-check"><input type="checkbox" :value="x.id" v-model="selectedPhotoIds"><span>选择</span></label><a :href="x.photo_url" target="_blank"><img :src="x.photo_url" alt="用户上传图片"></a><div class="photo-meta"><div><b>设备 {{x.device_sn||'-'}}</b><span>{{x.uploaded_at}}</span></div><button class="danger" @click="deletePhotos([x.id])">删除</button></div></div></div>
        <div class="empty-state" v-else><div class="empty-icon">图</div><h3>{{photoLoading?'正在加载…':'该用户尚未上传图片'}}</h3></div>
      </div>
    </div>
  </div>
</template>
<script>
import { api, errorMessage } from "../api";
export default {
  data: () => ({ rows: [], keyword: "", photoDialog:false,photoLoading:false,photoUser:{},photos:[],selectedPhotoIds:[] }),
  computed:{allPhotosSelected(){return this.photos.length>0&&this.selectedPhotoIds.length===this.photos.length}},
  created() {
    this.load();
  },
  methods: {
    async viewPhotos(user) {
      this.photoUser=user;this.photos=[];this.selectedPhotoIds=[];this.photoDialog=true;this.photoLoading=true;
      try { this.photos=(await api.get(`/admin/users/${user.id}/notice-photos`)).data.data||[]; }
      catch(e){alert(errorMessage(e));this.photoDialog=false}
      finally{this.photoLoading=false}
    },
    closePhotos(){this.photoDialog=false;this.photos=[];this.selectedPhotoIds=[]},
    toggleAllPhotos(e){this.selectedPhotoIds=e.target.checked?this.photos.map(x=>x.id):[]},
    async deletePhotos(ids){
      const list=[...ids];if(!list.length)return;
      if(!confirm(`确认删除选中的 ${list.length} 张图片？删除后不可恢复。`))return;
      try{const count=(await api.post('/admin/notice-photos/delete',{ids:list})).data.data||0;this.photos=this.photos.filter(x=>!list.includes(x.id));this.selectedPhotoIds=this.selectedPhotoIds.filter(id=>!list.includes(id));alert(`已删除 ${count} 张图片`)}catch(e){alert(errorMessage(e))}
    },
    async load() {
      try {
        this.rows =
          (await api.get("/admin/users", { params: { keyword: this.keyword } }))
            .data.data || [];
      } catch (e) {
        alert(errorMessage(e));
      }
    },
  },
};
</script>
<style scoped>
.page-actions {
  display: flex;
  gap: 8px;
}
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.user-cell > img,
.user-cell > span {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  background: #e4eff9;
  color: #245d91;
  display: grid;
  place-items: center;
  font-weight: 900;
}
.user-cell b,
.user-cell small {
  display: block;
}
.address-cell{min-width:190px;max-width:280px;white-space:normal;line-height:1.55}.code-cell{min-width:130px;word-break:break-all}
.user-cell small {
  color: #87938e;
  margin-top: 3px;
}
.photo-button{white-space:nowrap;padding:8px 12px}.photo-mask{position:fixed;inset:0;z-index:100;background:rgba(8,24,18,.58);display:flex;align-items:center;justify-content:center;padding:24px}.photo-dialog{width:min(960px,100%);max-height:88vh;overflow:auto;background:#fff;border-radius:18px;padding:20px;box-shadow:0 28px 70px rgba(0,0,0,.25)}.dialog-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-bottom:16px}.dialog-head h3{margin:0}.dialog-head p{margin:6px 0 0;color:#76857e}.dialog-head .close{width:38px;height:38px;padding:0;border-radius:50%;font-size:24px;background:#edf3f0;color:#395148;box-shadow:none}.photo-toolbar{display:flex;align-items:center;gap:12px;margin-bottom:14px;padding:10px 12px;background:#f4f8f6;border-radius:10px}.photo-toolbar label{display:flex;align-items:center;gap:6px}.photo-toolbar span{flex:1;color:#6b7d75}.photo-toolbar button:disabled{opacity:.45}.photo-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px}.photo-item{position:relative;border:1px solid #e1ebe6;border-radius:12px;overflow:hidden;background:#f8fbf9}.photo-item>a{display:block;color:#1d332a;text-decoration:none}.photo-grid img{display:block;width:100%;height:210px;object-fit:cover;background:#eef3f1}.photo-check{position:absolute;z-index:2;left:8px;top:8px;display:flex;align-items:center;gap:5px;padding:5px 8px;border-radius:8px;background:rgba(255,255,255,.92);box-shadow:0 4px 12px rgba(0,0,0,.12)}.photo-check span{font-size:12px}.photo-meta{display:flex;align-items:center;gap:8px;padding:10px}.photo-meta>div{flex:1;min-width:0}.photo-meta b,.photo-meta span{display:block}.photo-meta span{margin-top:4px;color:#7b8983;font-size:12px}.photo-meta button{padding:7px 10px}@media(max-width:700px){.photo-grid{grid-template-columns:repeat(2,minmax(0,1fr))}.photo-grid img{height:150px}.photo-toolbar{flex-wrap:wrap}.photo-toolbar span{flex-basis:40%}}
</style>
